import React, { useState, useEffect } from 'react';
import curve from '../../../assets/curve.svg';
import hireor from '../../../assets/Hire or.svg';
import getHired from '../../../assets/Get Hired.svg';
import backgroundImg from "../../../assets/background.svg"
import recr from "../../../assets/recruiterSvg.svg"
import candid from '../../../assets/candidateSvg.svg'
import busine from '../../../assets/businessSvg.svg'
import list from "../../../assets/jobpostDesc.svg"
import arrowUp from "../../../assets/arrow_warm_up.png"
import notesSeen from "../../../assets/hirdenotesCand.svg"
import listCheck from "../../../assets/list_alt_check.svg"
import eventList from "../../../assets/event_list.svg"
import postJob from "../../../assets/work_alert.svg"
import viewResume from "../../../assets/article_person.svg"
import TalentSourcing from "../../../assets/data_loss_prevention.svg"
import jobReq from "../../../assets/contact_emergency.svg"
import play from "../../../assets/play_circle.svg"
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getThreeJobs } from '../../../services/operations/JobPostAPI';
import DemoPage from './DemoPage';

const MainSection = ({ coords }) => {

  const [plans, setPlans] = useState([]);
  const location = useLocation()
  const dispatch = useDispatch()
  const base = window.location.origin
  const baseCandidateUrl = process.env.REACT_APP_CANDIDATE_URL
  const baseBusinessURl = process.env.REACT_APP_BUSINESS_URL


  function handleViewAllClick() {
    let url = `${base}/global-jobs`;

    /*if (coords && coords.lat && coords.lng) {
      url += `?lat=${coords.lat}&lng=${coords.lng}`;
    }*/

    window.open(url, '_blank');
  }



  const getPlans = async () => {
    const response = await dispatch(getThreeJobs());
    setPlans(response?.data?.data)
  };

  useEffect(() => {
    getPlans();
  }, []);


  const onscroll = (id) => {
    const section = document.querySelector(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="hero">
      <div className="hero-left">
        <div style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
          <img src={hireor} style={{ width: "245px" }} />
          <img src={getHired} style={{ width: "245px" }} />
        </div>
        <p className="sub-heading">Find Your Perfect Candidate or Job</p>
        <p className="description">
          The leading platform connecting candidates, hiring managers, and recruiters globally.
        </p>
        <div className="hero-buttons">
          {/* <button className="demo-btn" onClick={()=>window.open("https://www.youtube.com/@1800HIRED","_blank")}>Get Demo</button> */}
          <DemoPage />
          <button className="explore-btn" onClick={() => onscroll("#whatwedo")}>Explore 1800hired</button>
        </div>
        <p className="no-card">No credit card required</p>
        <div className="applicant-table-card">
          <div className="table-title">
            <p>Current <span style={{ color: "rgba(53, 116, 214, 1)", fontWeight: "700" }}>openings</span></p>
            <p style={{ color: "rgba(173, 173, 173, 1)", fontSize: "14px", fontWeight: "400", cursor: "pointer" }} onClick={handleViewAllClick} >View all</p>
          </div>
          <div className="table-scroll-wrapper">
            <table className="applicant-table">
              <tbody>
                {plans?.length > 0 &&
                  plans.map((job, index) => (
                    <tr key={job.id || index}
                      onClick={() => {
                        const encodedJob = encodeURIComponent(btoa(JSON.stringify(job.id)));
                        window.open(`${base}/job-detailing?job=${encodedJob}`);
                      }}
                      style={{ cursor: "pointer" }}
                      className="zoom-hover-effect">
                      <td style={{ color: "rgba(0,0,0,0.7)", fontWeight: "600" }}>{job.company_name}</td>
                      <td style={{ color: "rgba(0,0,0,0.6)", fontWeight: "400" }}>{job.job_title}</td>
                      <td style={{ color: "rgba(0,0,0,0.6)", fontWeight: "400" }}>{job.job_location}</td>
                      <td>
                        <button className={`employment-type-btn ${job.workplace_type === "Remote"
                          ? "remote"
                          : job.workplace_type === "Onsite"
                            ? "onsite"
                            : "hybrid"
                          }`}
                          style={{ width: "58px", height: "21px", fontWeight: "700", fontSize: "11px" }}
                        >
                          {job.workplace_type}
                        </button>
                      </td>
                      <td style={{ color: "rgba(0,0,0,0.5)", fontWeight: "700" }}>
                        {(
                          job?.salary_range &&
                          job.salary_range !== "N/A" &&
                          job.salary_range.trim() !== ""
                        )
                          ? job.salary_range
                          : (
                            job?.contract_price_per_hrs &&
                            job.contract_price_per_hrs !== "N/A" &&
                            job.contract_price_per_hrs !== ""
                          )
                            ? `${job.contract_price_per_hrs}/hr`
                            : "N/A"}
                      </td>

                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>

      <div className="hero-right">
        <img src={curve} alt="curve" className="curve" />

        <div className="stats-resume-count">
          <div className='stat-resume'>
            <h3 className="stat-resume-count-number">80M+</h3>
            <p className="stat-count-desc">Total Resume uploaded</p>
          </div>
          <span className="stat-navigate-icon">{">"}</span>
        </div>
        <button className='close-view-button'>Close post</button>
        <div className="floating-card-candidate" onClick={() => window.open(`${baseCandidateUrl}`, "_blank")}>
          <img src={candid} />
          <p className='card-heading'>FOR CANDIDATES</p>
          <div className='button-card-view-detail'>
            <button className='hired-btn-view'>Get hired</button>
            <button className='hired-btn-view' style={{ width: "75px" }}>Track Your Applications</button>
          </div>
          <div className='hidden-divpart'>
            <div className='hidden-desc-part'>
              <img src={listCheck} className='hidden-desc-image' />
              <button className='hidden-desc-button-one'>Submit Resume</button>
            </div>
            <div className='hidden-desc-part'>
              <img src={eventList} className='hidden-desc-image' />
              <button className='hidden-desc-button-two'>Apply Job</button>
            </div>
          </div>
          <div className="hidden-list">
            <li className="hidden-list-item">
              <svg className="hidden-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="hidden-item-text">Job Alerts</span>
            </li>
            <li className="hidden-list-item">
              <svg className="hidden-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="hidden-item-text">Resume Management</span>
            </li> <li className="hidden-list-item">
              <svg className="hidden-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="hidden-item-text">Interview Scheduling </span>
            </li>
            <li className="hidden-list-item">
              <svg className="hidden-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="hidden-item-text">Profile Analytics</span>
            </li>
            <li className="hidden-list-item">
              <svg className="hidden-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="hidden-item-text">Application Status</span>
            </li>
          </div>
        </div>
        <div className="floating-card-recruiter"
          onClick={() => window.open(`${base}/login`, "_blank")}
        >
          <img src={recr} />
          <p className='card-heading'>FOR RECRUITERS</p>
          <div className='button-card-view-detail'>
            <button className='hired-btn-view'>Hire globally</button>
            <button className='hired-btn-view'>Schedule Interviews</button>
          </div>
          <div className='hidden-divpart'>
            <div className='hidden-desc-part'>
              <img src={TalentSourcing} className='hidden-desc-image' />
              <button className='hidden-desc-button-one'>Talent Sourcing</button>
            </div>
            <div className='hidden-desc-part'>
              <img src={jobReq} className='hidden-desc-image' />
              <button className='hidden-desc-button-two'>Job Requisitions</button>
            </div>
          </div>
          <div className="hidden-list">
            <li className="hidden-list-item">
              <svg className="hidden-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="hidden-item-text">Applicant Tracking System</span>
            </li>
            <li className="hidden-list-item">
              <svg className="hidden-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="hidden-item-text">Job Postings</span>
            </li> <li className="hidden-list-item">
              <svg className="hidden-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="hidden-item-text">Candidate Sourcing</span>
            </li>
            <li className="hidden-list-item">
              <svg className="hidden-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="hidden-item-text">Team Collaboration</span>
            </li>
            <li className="hidden-list-item">
              <svg className="hidden-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="hidden-item-text">Job Requisition Metric</span>
            </li>
          </div>
        </div>
        <div className="floating-card-business"
          onClick={() => window.open(`${baseBusinessURl}`, "_blank")}
        >
          <img src={busine} />
          <p className='card-heading'>FOR BUSINESS</p>
          <div className='button-card-view-detail'>
            <button className='hired-btn-view'>Post a job</button>
            <button className='hired-btn-view'>Schedule Interviews</button>
          </div>
          <div className='hidden-divpart'>
            <div className='hidden-desc-part'>
              <img src={postJob} className='hidden-desc-image' />
              <button className='hidden-desc-button-one'>Post Job</button>
            </div>
            <div className='hidden-desc-part'>
              <img src={viewResume} className='hidden-desc-image' />
              <button className='hidden-desc-button-two'>View Resumes</button>
            </div>
          </div>
          <div className="hidden-list">
            <li className="hidden-list-item">
              <svg className="hidden-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="hidden-item-text">Job Market Analytics</span>
            </li>
            <li className="hidden-list-item">
              <svg className="hidden-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="hidden-item-text">Team Management</span>
            </li> <li className="hidden-list-item">
              <svg className="hidden-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="hidden-item-text">Hiring Strategy Insights</span>
            </li>
            <li className="hidden-list-item">
              <svg className="hidden-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="hidden-item-text">Recruitment Metrics</span>
            </li>
            <li className="hidden-list-item">
              <svg className="hidden-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="hidden-item-text">Compliance & Reporting</span>
            </li>
          </div>
        </div>
        {/* Add stats cards and others */}
        <img src={list} className="list-view-button" />
        <button className='remote-button'>Remote</button>
        <button className='applicant-view-button'>
          <img src={arrowUp} alt="up" />
          &nbsp;&nbsp;{Math.floor(Math.random() * 50) + 1} New Applicants
        </button>
        <button className='see-notes-view-button'>See Notes</button>
        <img src={play} className='play-button' />
        <img src={notesSeen} className='notes-view-button' />
        <div className="stats-pending-count">
          <div className='stat-resume'>
            <h3 className="stat-resume-count-number">5</h3>
            <p className="stat-count-desc">Pending Applications</p>
          </div>
          <span className="stat-navigate-icon" style={{ backgroundColor: "rgba(245, 245, 245, 1)" }}>{">"}</span>
        </div>
      </div>
    </section>
  );
};

export default MainSection;
